import moment from "moment-timezone"
import React from "react"
import ReactDOM from "react-dom/client"
import "./main.css"

import App from "./App"

import "./lib/i18n"
// import { enableMocking } from "./mock"

// setup timezone
moment.tz.setDefault("Asia/Kolkata")

// Enable mocking in development

// enableMocking().then(() => {
//   ReactDOM.createRoot(document.getElementById("root")).render(
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   )
// })

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
